import { ARTIST, siteImg } from "@/lib/constants";
import { ArtFrame, Bindi, Reveal, SectionHeading } from "@/components/motifs";
import { ARTIST_LEAD, ARTIST_QUOTE, STAGES } from "@/content/chapters";

export const ArtistChapter = ({ quote, headingAs }) => (
  <section id="artist" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="artist-section">
    <SectionHeading number="01" title="The Artist" note="A life, redrawn" as={headingAs} />

    <div className="grid gap-16 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Reveal>
          <ArtFrame className="sticky top-28">
            <img
              src={siteImg("/assets/portrait.jpg")}
              alt={`Portrait of ${ARTIST.name}`}
              className="block h-auto w-full"
              data-testid="artist-portrait"
            />
            <div className="flex items-center justify-between bg-paper px-4 py-3">
              <p className="font-serif text-lg italic">{ARTIST.name}</p>
              <p className="eyebrow flex items-center gap-2 text-muted-foreground">
                <Bindi size={6} /> Bhopal
              </p>
            </div>
          </ArtFrame>
        </Reveal>
      </div>

      <div className="lg:col-span-7">
        <Reveal>
          <p className="font-serif text-xl leading-relaxed sm:text-2xl">
            {ARTIST_LEAD}
          </p>
        </Reveal>

        <div className="mt-14 space-y-0">
          {STAGES.map((stage, i) => (
            <Reveal key={stage.title} delay={0.05 * i}>
              <div className="group relative grid gap-2 border-l border-border py-8 pl-8 sm:grid-cols-[140px_1fr] sm:gap-8">
                <span className="absolute -left-[5px] top-10">
                  <Bindi size={9} className="transition-transform duration-500 group-hover:scale-125" />
                </span>
                <p className="eyebrow pt-1 text-muted-foreground">{stage.mark}</p>
                <div>
                  <h3 className="font-serif text-xl font-medium tracking-tight sm:text-2xl">{stage.title}</h3>
                  <p className="mt-3 max-w-xl text-sm leading-relaxed text-muted-foreground">{stage.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <blockquote className="mt-10 border-l-2 border-accent py-2 pl-8">
            <p className="font-serif text-xl italic leading-relaxed sm:text-2xl">
              "{quote || ARTIST_QUOTE}"
            </p>
            <cite className="eyebrow mt-4 block not-italic text-muted-foreground">
              — {ARTIST.name} · The journey continues
            </cite>
          </blockquote>
        </Reveal>
      </div>
    </div>
  </section>
);
